<template>
  <div id="app">
    <div class="pageloader" :class="{ 'is-active': isLoading }"></div>
      <section class="hero">
        <!-- Hero head: will stick at the top -->
        <div class="hero-head">
          <app-header/>
        </div>
        <!-- Hero content: will be in the middle -->
        <router-view></router-view>
        <!-- Hero footer: will stick at the bottom -->
        <div class="hero-foot">
          <app-footer/>
        </div>
      </section>
  </div>
</template>

<script>

import Header from './components/Header'
import Footer from './components/Footer'
import { get } from 'vuex-pathify'

export default {
  components: {
    appHeader: Header,
    appFooter: Footer
  },
  computed: {
    isLoading: get('loading')
  },
  metaInfo: {
    title: 'READ-THAI.COM',
    titleTemplate: '%s | นิยายแปลไทย',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { property: 'og:title', content: 'READ-THAI.COM' },
      { property: 'og:description', content: 'นิยายแปลไทย' },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: 'https://www.img.in.th/images/823ea6f7cfc16c8937fb196b733cab27.png' },
      { property: 'og:url', content: 'https://read-thai.com/#/' }
    ]
  }
}
</script>

<style lang="scss">
@import '@/scss/base.scss';

.unselectable {
  user-select: none;
}
</style>
